import React from 'react';

/**
 * SelectGoukiKotei
 */
class SelectGoukiKotei extends React.Component {

  render() {
    let style = {
      color: 'var(--color-scheme-text-inactive)'
    };
    let style2 = {
      color: 'var(--color-scheme-text-inactive)',
      padding: '5px',
      background: 'transparent',
      backgroundColor: 'var(--color-scheme-UI-filter-10)',
      borderRadius: '3px',
      boxSizing: 'border-box'
    };

    return (
      <div>
        <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable"><p style={style}>号機</p></div>
        <div className="ctrl_form_kubun"><p style={style2}>-</p></div>
      </div>
    );
  }
}

export default SelectGoukiKotei;
